import { getWindowBaseURL } from "./get-base-url";

export function createFormLink(tenantSubDomain: string, appointmentId: string) {
  return `${getWindowBaseURL(tenantSubDomain)}/appointment/${appointmentId}/forms`;
}
